import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription, filter } from 'rxjs';
import { IframeService } from '../shared/services/iframe.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { Router, NavigationEnd  } from '@angular/router';
import { getACLocationSelected } from './../state/index';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { AppInitService } from 'src/app/app-init.service';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent implements OnInit, OnDestroy {

  @ViewChild('myIframe', { static: true }) iframeRef!: ElementRef<HTMLIFrameElement>;
  private subscriptions = new Subscription();
  isLoading = true;
  private appConfig!: AppConfigurations;
  acUrlInitialized = false;
  private acPopupOpened : boolean = false;

  private acUrl: string = "";
  private acLocationId: number = 1;   

  public iframeUrl: SafeResourceUrl | null = null;
  constructor(private iframeService: IframeService, 
    private sanitizer: DomSanitizer, 
    private router: Router, 
    private store: Store<State>,
    private appInitService: AppInitService,) { }

  ngOnInit() {

    this.appInitService.getAppConfiguration$().subscribe({
      next: (config) => {
        this._onReceiveAppConfig(config);
      }
    })

    this.handleRouteChange();
    this.subscriptions.add(
      this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(event => {
        this.handleRouteChange();
      })
    );

    this.subscriptions.add(
      this.iframeService.iframeUrl$.subscribe((url: string | null) => {
        this.iframeUrl = url
          ? this.sanitizer.bypassSecurityTrustResourceUrl(url)
          : null;
      })
    );

    this.subscriptions.add(
      this.iframeService.iframeCommand$.subscribe(command => {
        if (this.iframeRef?.nativeElement?.contentWindow) {
          this.iframeRef.nativeElement.contentWindow.postMessage(command, '*');
        }
      })
    );

    this.subscriptions.add(
      this.iframeService.popupOpened$.subscribe((name: string | null) => {
        if (name === 'POPUP_OPENED') {
          this.acPopupOpened = true;
        }
      })
    );

    window.addEventListener('message', this.handleIframeMessage);
    window.addEventListener('message', this.onMessageFromIframe);

    const locationCodeSubscription = this.store.select(getACLocationSelected)
      .subscribe((selectedLocation) => {
        if (selectedLocation != null) {
          this.acLocationId = selectedLocation;
        }
      });
      this.subscriptions.add(locationCodeSubscription);
  }

    private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.acUrl = this.appConfig.ac.acPortalUrl;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    window.removeEventListener('message', this.onMessageFromIframe);
    window.removeEventListener('message', this.handleIframeMessage);
  }

  private handleRouteChange(): void {
    const currentUrl = this.router.url;
    let subPath = '';

    if (currentUrl.includes('/appointment/administration')) subPath = 'administration';
    else if (currentUrl.includes('/appointment/manageevents')) subPath = 'manageevents';
    else if (currentUrl.includes('/appointment/actioncenter')) subPath = 'actioncenter';
    else if (currentUrl.includes('/appointment/reports/appt-detail-report')) subPath = 'reports/appt-detail-report';
    else if (currentUrl.includes('/appointment/reports/trend-view')) subPath = 'reports/trend-view';
    else if (currentUrl.includes('/appointment/reports/campaigns-view')) subPath = 'reports/campaigns-view';
    else subPath = 'appointments';

    const iframeFullUrl = `${this.acUrl}${subPath}?ccEnabledClient=true&locationCode=${this.acLocationId}`;
    if (!this.acUrlInitialized) {
      this.isLoading = true;
      this.acUrlInitialized = true;
      this.iframeService.setUrl(iframeFullUrl);
    } else {
      const popupClosed = this.checkAcPopupOpened(`/${subPath}`);
      if (!popupClosed) {
        this.iframeService.sendCommand({ type: 'SWITCH_TAB', tabName: `/${subPath}` });
      }
    }
  }

  private checkAcPopupOpened(tabName: string): boolean {
    if (this.acPopupOpened) {
      this.iframeService.sendCommand({ type: 'CLOSE_POPUP', tabName });
      this.acPopupOpened = false;
      return true;
    }
    return false;
  }

  private handleIframeMessage = (event: MessageEvent) => {
    const message = event.data;
    if (message?.type === 'AC_POPUP') {
      this.iframeService.setPopupOpened(message.popupName);
    }
  };

  onMessageFromIframe = (event: MessageEvent) => {
    if (event.data === 'iframe-app-loaded') {
      this.isLoading = false;
    }
  };
}
